/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ dateTime: NonNullable<unknown> }} Coinvestments_Senddrafts_Toast_Scheduledone3Inputs */

const en_coinvestments_senddrafts_toast_scheduledone3 = /** @type {(inputs: Coinvestments_Senddrafts_Toast_Scheduledone3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`1 draft scheduled for ${i?.dateTime}`)
};

/**
* | output |
* | --- |
* | "1 draft scheduled for {dateTime}" |
*
* @param {Coinvestments_Senddrafts_Toast_Scheduledone3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_senddrafts_toast_scheduledone3 = /** @type {((inputs: Coinvestments_Senddrafts_Toast_Scheduledone3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Senddrafts_Toast_Scheduledone3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_senddrafts_toast_scheduledone3(inputs)
});
export { coinvestments_senddrafts_toast_scheduledone3 as "coInvestments_sendDrafts_toast_scheduledOne" }